import {
  useAvailableDailyHeartfelt,
  useAvailableUnlimitedDailyHeartfelt,
} from 'src/react_query'
import { useEffect } from '.'
import { useState } from './useState'

const useHeartfeltWarningBannerInfo = () => {
  const {
    data: availableUDHeartfelt,
    isFetching: isFetchingAvailableUDHeartfelt,
  } = useAvailableUnlimitedDailyHeartfelt()
  const {
    data: availableDHeartfelt,
    isFetching: isFetchingAvailableDHeartfelt,
  } = useAvailableDailyHeartfelt()
  const [shouldDisplayWarningBanner, setShouldDisplayWarningBanner] =
    useState(false)
  const warningBannerCap =
    !!availableUDHeartfelt && availableUDHeartfelt.hasUnlimitedHeartfeltSends
      ? availableUDHeartfelt.heartfeltDailyCap.cap
      : !!availableDHeartfelt && availableDHeartfelt?.hasDailyHeartfeltSends
        ? availableDHeartfelt.dailyHeartfeltCap.cap
        : 0

  useEffect(() => {
    if (!isFetchingAvailableDHeartfelt && !isFetchingAvailableUDHeartfelt) {
      setShouldDisplayWarningBanner(
        (!!availableDHeartfelt &&
          availableDHeartfelt.hasDailyHeartfeltSends &&
          availableDHeartfelt.dailyHeartfeltCap.available === 0) ||
          (!!availableUDHeartfelt &&
            availableUDHeartfelt.hasUnlimitedHeartfeltSends &&
            availableUDHeartfelt.heartfeltDailyCap.available === 0),
      )
    }
  }, [
    availableDHeartfelt,
    availableUDHeartfelt,
    isFetchingAvailableDHeartfelt,
    isFetchingAvailableUDHeartfelt,
  ])

  return {
    shouldDisplayWarningBanner,
    warningBannerCap,
    setShouldDisplayWarningBanner,
  }
}

export default useHeartfeltWarningBannerInfo
